import { Link } from "gatsby"
import Img from "gatsby-image"
import React from "react"

import { iArticleTopicForPageContext, iTopicMetaData } from "../types"

const TopicCardView: React.FC<iTopicMetaData> = ({ title, image, Icon }) => {
  return (
    <div className="h-full relative site-border-radius overflow-hidden hover:shadow border bg-gray-100">
      <Img
        fluid={image}
        style={{
          height: "270px",
        }}
        className="w-full hidden md:block"
      />
      <Img
        fluid={image}
        style={{
          height: "240px",
        }}
        className="w-full block md:hidden"
      />
      <div className="absolute bottom-0 left-0 w-full flex justify-start">
        <div
          className="bg-gray-100 flex items-center p-3 site-border-radius-tr"
          style={{ width: "80%" }}
        >
          <p className="text-site-blue-dark border bg-white text-lg px-2 p-2 mr-3 rounded-full">
            {Icon}
          </p>
          <p className="text-site-blue-dark text-lg font-bold">{title}</p>
        </div>
      </div>
    </div>
  )
}

export const ArticleTopicCard: React.FC<iArticleTopicForPageContext> = ({
  title,
  slug,
  image,
  description,
  slugPrefix,
  Icon,
}) => {
  return (
    <Link to={`/${slugPrefix || "topics"}/${slug}`}>
      <TopicCardView
        title={title}
        image={image}
        description={description}
        Icon={Icon}
      />
    </Link>
  )
}
